import Vue from 'vue'
import Vuex from 'vuex'
import { getDomain } from '@/api/cookies'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 机构类型兼容数字和字符串；统一控制所有购买、下单及支付入口。
    hidePurchaseButtons: Number((getDomain() || {}).entrantsType) === 8,
    // 基础状态
    userInfo: null,
    loading: false
  },
  getters: {
    getUserInfo: state => state.userInfo,
    isLoading: state => state.loading
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    }
  },
  actions: {
    // 异步操作示例
    async setUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    },
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    }
  }
})
